import { UiFlagsStore } from "../stores/uiFlagsStore";

export enum PartnerNames {
  default = "default",
  sobol = "sobol",
  directTuz = "directTuz"
}

export class Partner {
  public static checkIfOnPartnerWebsite(uiFlagsStore: UiFlagsStore, partnerName: PartnerNames) {
    return uiFlagsStore.partnerName === partnerName;
  }

  public static checkIsCorrectPartnerName(partnerName: string) {
    return Object.keys(PartnerNames).includes(partnerName);
  }
}
